module.exports = __webpack_public_path__ + "img/check-circle-navy.e15c50c0.svg";